import { render, staticRenderFns } from "./handCreated.vue?vue&type=template&id=33ee27ae&scoped=true"
import script from "./handCreated.vue?vue&type=script&lang=js"
export * from "./handCreated.vue?vue&type=script&lang=js"
import style0 from "./handCreated.vue?vue&type=style&index=0&id=33ee27ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ee27ae",
  null
  
)

export default component.exports